import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--down",
  "use": "icon-arrow--down-usage",
  "viewBox": "0 0 11 8",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 8\" id=\"icon-arrow--down\"><path d=\"M6.121 6.154a.988.988 0 0 1 0 1.322.834.834 0 0 1-.613.274.834.834 0 0 1-.613-.274L.27 2.488C-.548 1.607.678.284 1.496 1.166l4.625 4.988H4.895L9.52 1.166a.823.823 0 0 1 1.226 0 .988.988 0 0 1 0 1.322L6.121 7.476a.834.834 0 0 1-.613.274.834.834 0 0 1-.613-.274L.27 2.488l1.226-1.322 4.625 4.988Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol